export const style = `
.Select-input input{
  border:0px solid!important;
}
.Select-menu-outer{
  z-index:7;
}
`;

export default style;



// WEBPACK FOOTER //
// ./app/components/Forms/UI/AsyncSelect/style.js